// src/components/ReviewSummary.jsx
import React from 'react';
// import { convertToCamelCase } from '../utils/caseConverter';
// import { checkboxCategories } from '../config/formOptions';
import { Box } from '@mui/material';
// import { initialFormState } from './ReviewForm';
// import TwoWaySlider from './common/TwoWaySlider'; // Adjust the path as necessary
// import ReviewLabelDisplay from './common/ReviewLabelDisplay';
// import sliderConfig from '../config/sliderConfig'; // Adjust the path as necessary
// import { convertToCamelCase } from '../utils/caseConverter';
import ReviewSummaryChart from './common/ReviewSummaryChart';
import { aggregateReviewDataByPosition } from '../utils/reviewDataUtils';


// TODO: Revisit the use of React.memo for ReviewSummary to ensure optimal performance. Consider evaluating:
//  - The frequency of prop changes and the impact on re-renders.

// A functional component for ReviewSummary
const ReviewSummary = ({ reviewData }) => {
    console.log("ReviewSummary reviewData:", reviewData); // TODO remove in production

    const aggregatedReviewDataByPosition = aggregateReviewDataByPosition(reviewData);
    console.log("Aggregated review data:", aggregatedReviewDataByPosition); // TODO remove in production



    // // Function to aggregate review data
    // const aggregateReviewData = (reviews) => {
    //     let aggregatedData = {};
    //     // let booleanFields = ['graduate_on_time', 'recommend_advisor'];
    //     // let sliderFields = Object.keys(initialFormState).filter(key => typeof initialFormState[key] === 'number');
    //     let booleanFields = ['graduateOnTime', 'recommendAdvisor'];
    //     let sliderFields = Object.keys(sliderConfig);
    //
    //     reviews.forEach(review => {
    //         const camelCaseReview = convertToCamelCase(review);
    //
    //         // Aggregate slider fields
    //         sliderFields.forEach(field => {
    //             if (camelCaseReview[field] !== null && camelCaseReview[field] !== undefined) { // Skip null and undefined
    //                 if (!aggregatedData[field]) {
    //                     aggregatedData[field] = {total: 0, count: 0};
    //                 }
    //                 aggregatedData[field].total += Number(camelCaseReview[field]); // Ensure value is treated as a number
    //                 aggregatedData[field].count += 1;
    //             }
    //         });
    //
    //         // Aggregate boolean fields
    //         booleanFields.forEach(field => {
    //             if (camelCaseReview[field] !== null && camelCaseReview[field] !== undefined) { // Skip null and undefined
    //                 if (!aggregatedData[field]) {
    //                     aggregatedData[field] = {trueCount: 0, count: 0};
    //                 }
    //                 if (camelCaseReview[field] === true) {
    //                     aggregatedData[field].trueCount += 1;
    //                 }
    //                 aggregatedData[field].count += 1;
    //             }
    //         });
    //     });
    //
    //     // Calculate averages for slider fields or use the single value if only one review
    //     Object.keys(aggregatedData).forEach(key => {
    //         if (sliderFields.includes(key)) {
    //             aggregatedData[key] = aggregatedData[key].count > 0 ? parseFloat((aggregatedData[key].total / aggregatedData[key].count).toFixed(1)) : 0;
    //         } else if (booleanFields.includes(key)) {
    //             aggregatedData[key] = aggregatedData[key].count > 0 ? parseFloat(((aggregatedData[key].trueCount / aggregatedData[key].count) * 100).toFixed(1)) : 0;
    //         }
    //     });
    //
    //     // // Calculate averages for slider fields or use the single value if only one review
    //     // Object.keys(aggregatedData).forEach(key => {
    //     //     if (sliderFields.includes(key)) {
    //     //         if (aggregatedData[key].count > 0) {
    //     //             let average = aggregatedData[key].total / aggregatedData[key].count;
    //     //             aggregatedData[key] = parseFloat(average.toFixed(1)); // Round to 1 decimal place
    //     //         } else {
    //     //             aggregatedData[key] = 0; // Default to 0 if no data
    //     //         }
    //     //     } else if (booleanFields.includes(key)) {
    //     //         aggregatedData[key] = aggregatedData[key].count > 0 ? parseFloat(((aggregatedData[key].trueCount / aggregatedData[key].count) * 100).toFixed(1)) : 0; // Round percentage to 1 decimal place
    //     //     }
    //     // });
    //
    //     // // Include all other numerical fields from the review when there's only one review
    //     // if (reviews.length === 1) {
    //     //     let review = reviews[0];
    //     //     Object.keys(review).forEach(key => {
    //     //         if (typeof review[key] === 'number' && !sliderFields.includes(key) && !booleanFields.includes(key)) {
    //     //             aggregatedData[key] = review[key];
    //     //         }
    //     //     });
    //     // }
    //
    //     // Debugging logs
    //     Object.keys(aggregatedData).forEach(key => {
    //         console.log(`Key: ${key}, Value: ${aggregatedData[key]}`);
    //     });
    //
    //     return aggregatedData;
    // };

    // const aggregatedReviewData = aggregateReviewData(reviewData);
    // console.log("Aggregated review data:", aggregatedReviewData); // TODO remove in production

    // Convert aggregatedReviewData keys to camelCase
    // const camelCaseAggregatedData = convertToCamelCase(aggregatedReviewData);


    // // Filter out only the relevant slider data based on sliderFields
    // const sliderData = Object.keys(camelCaseAggregatedData)
    //     .filter(key => Object.keys(sliderConfig).includes(key)) // Ensure the key is part of the sliderConfig
    //     .reduce((obj, key) => {
    //         obj[key] = camelCaseAggregatedData[key];
    //         return obj;
    //     }, {});


    return (
        <Box className="page-container" sx={{ width: '100%' }}>
            {/* Chart Section */}
            <Box sx={{ my: 4, height: '300px' }}> {/* Assign a minimum height to the chart container */}
                <ReviewSummaryChart aggregatedReviewDataByPosition={aggregatedReviewDataByPosition} />
            </Box>

            {/*{Object.keys(sliderConfig).map((key, index) => {*/}
            {/*    if (sliderData[key] === null || sliderData[key] === undefined) {*/}
            {/*        console.warn(`No slider data found for key: ${key}`); // TODO remove in production*/}
            {/*        return null;*/}
            {/*    }*/}

            {/*    const config = sliderConfig[key];*/}
            {/*    return (*/}
            {/*        <Box key={index} my={2}> /!* 'my' is margin top & bottom for spacing *!/*/}
            {/*            <ReviewLabelDisplay*/}
            {/*                value={sliderData[key]}*/}
            {/*                labelLeft={config.labelLeft}*/}
            {/*                labelRight={config.labelRight}*/}
            {/*            />*/}
            {/*        </Box>*/}
            {/*    );*/}
            {/*})}*/}

            {/* TwoWaySlider Components */}
            {/*<Box>*/}
            {/*    {Object.keys(sliderConfig).map((key, index) => {*/}
            {/*        if (sliderData[key] === null || sliderData[key] === undefined) {*/}
            {/*            console.warn(`No slider data found for key: ${key}`); // TODO remove in production*/}
            {/*            return null;*/}
            {/*        }*/}

            {/*        const config = sliderConfig[key];*/}
            {/*        return (*/}
            {/*            <Box key={index} my={2}> /!* 'my' is margin top & bottom for spacing *!/*/}
            {/*                <TwoWaySlider*/}
            {/*                    name={key}*/}
            {/*                    labelLeft={config.labelLeft}*/}
            {/*                    labelRight={config.labelRight}*/}
            {/*                    min={config.min}*/}
            {/*                    max={config.max}*/}
            {/*                    value={sliderData[key]}*/}
            {/*                    readOnly={true}*/}
            {/*                    // No onChange since this is for display only*/}
            {/*                    // Slider is non-interactive in this context*/}
            {/*                />*/}
            {/*            </Box>*/}
            {/*        );*/}
            {/*    })}*/}
            {/*</Box>*/}
        </Box>
    );
};

export default ReviewSummary;
